import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { typeToPluralUserVisibleString } from '../../../../library/selection/types';
import { PartialMirrorTransformation, TransformableType } from '../../../../library/transformations/types';
import { isTransformationFullyDefined } from '../../../../library/transformations/validation';
import {
  applyPendingTransformationIfFullyDefined,
  cancelTransformation,
} from '../../../../store/actions/layout/transformationActions';
import { useAppDispatch } from '../../../hooks';
import { LayoutLinePickerField } from '../../subpanels/insertions/truss-envelope/LayoutLinePickerField';

export function MirrorControls(props: { targetType: TransformableType; transformation: PartialMirrorTransformation }) {
  const dispatch = useAppDispatch();

  return (
    <>
      <Typography sx={{ padding: 1 }}>
        {props.transformation.duplicate ? 'Duplicate and mirror' : 'Mirror'} the selected{' '}
        {typeToPluralUserVisibleString(props.targetType)} across a center line.
      </Typography>

      <Box sx={{ margin: 1, padding: 1 }}>
        <LayoutLinePickerField label="Mirror Line" value={props.transformation.center} target="transformation-center" />
      </Box>

      <Box sx={{ padding: 1, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
        <Button variant="outlined" onClick={() => dispatch(cancelTransformation())}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={() => void dispatch(applyPendingTransformationIfFullyDefined())}
          disabled={!isTransformationFullyDefined(props.transformation)}
        >
          Apply
        </Button>
      </Box>
    </>
  );
}
